import React, { useEffect } from "react";
import { Dialog, Box, IconButton } from "@mui/material";
import CommentSection from "../../../../components/shared/commentSection";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { getMakeoverComments } from "../../../../redux/listings/makeover/getMakeComments";
import { addMakeoverComment } from "../../../../redux/listings/makeover/addMakeoverComment";
import { resetMakeoverComments } from "../../../../redux/listings/makeover";
import { getSocket } from "../../../../config/socket.js";
import { handleUpdateMakeoverComment } from "../../../../redux/listings/makeover";

function Comments(props) {
  const { open, handleClose, classes, projectDetail } = props;
  const dispatch = useDispatch();
  const makeoverComments = useSelector(
    (state) => state.listings.makeover.makeoverComments
  );

  const usersList = useSelector((state) => state.users.storedListOfUsers.list);
  const adminAuth = useSelector((state) => state.adminAuth.adminDetail);

  useEffect(() => {
    if (projectDetail?.id && open) {
      dispatch(getMakeoverComments({ id: projectDetail?.id }));
    }
  }, [open]);

  const handleSubmitComment = (data) => {
    if (data?.value?.length > 0 && data?.value?.trim() !== "") {
      dispatch(
        addMakeoverComment({
          id: projectDetail?.id,
          schema: {
            mentionedUserIds: data?.userIds,
            content: data?.value,
          },
          otherValues: {
            makeover_id: projectDetail?.id,
            added_by: adminAuth?.id,
            content: data?.value,
            createdAt: new Date(),
          },
        })
      );
    }
  };
  const handleCloseDialog = () => {
    dispatch(resetMakeoverComments());
    handleClose(false);
  };

  useEffect(() => {
    if (!open) return;

    const socket = getSocket();
    if (socket) {
      // Check connection status
      if (socket.connected) {
        console.log("Socket is already connected.");
      } else {
        console.log("Socket is not connected. Attempting to connect...");
        socket.connect(); // Optionally attempt to connect
      }

      // Attach event listeners
      const handleUpdateComment = (data) => {
        if (projectDetail?.id !== Number(data?.makeover.id)) return;
        dispatch(
          handleUpdateMakeoverComment({
            makeover_id: projectDetail?.id,
            added_by: adminAuth?.id,
            content: data?.makeover?.comment,
            createdAt: new Date(),
          })
        );
      };

      socket.on("makeover_comment_created", handleUpdateComment);

      // Cleanup event listeners on component unmount
      return () => {
        socket.off("makeover_comment_created", handleUpdateComment);
      };
    } else {
      console.error(
        "Socket is undefined. Ensure establishSocketConnection was called first."
      );
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={handleCloseDialog} fullWidth maxWidth="sm">
      <Box sx={{ position: "relative" }}>
        <Box sx={{ position: "absolute", top: 0, right: 0 }}>
          <IconButton onClick={handleCloseDialog}>
            <CloseIcon />
          </IconButton>
        </Box>
        <CommentSection
          comments={
            makeoverComments.data?.length
              ? makeoverComments.data?.map((item) => ({
                  ...item,
                  comment: item.content,
                  user: usersList.find((user) => user.id === item.added_by),
                }))
              : []
          }
          height={"100%"}
          innerHeight={"75vh"}
          handleSubmitComment={handleSubmitComment}
          id="message-field-makeover"
          innerBackground={"#F6F6F6"}
          disableHeaderBorder={true}
          isLoading={makeoverComments.isLoading}
          {...props}
        />
      </Box>
    </Dialog>
  );
}

export default Comments;
